module.exports = __webpack_public_path__ + "img/logo-negative-cdp.7598a418.svg";